import React from 'react';
import useDataGrid from '@afosto/utils-react/datagrid/useDataGrid';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useHistory } from 'react-router';
import HandlingListStatus from '../../../../components/HandlingListStatus';
import { useShipmentContext } from '../../../../components/ShipmentProvider';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DataGrid from '@afosto/app-components-react/DataGrid';
import DataList from '@afosto/app-components-react/DataList';
import dataSourceRequest from '@afosto/utils-react/dataSource/dataSourceRequest';
import { handling as handlingApi } from '@afosto/fulfilment/api/Handling';
import { handlingListFormatter, statusFormatter } from './formatters';
import translations from './translations';

const ShipmentHandlingListSection = () => {
  const history = useHistory();
  const intl = useIntl();
  const { shipment } = useShipmentContext();

  const fetchHandlingList = async dataSource =>
    dataSourceRequest(
      dataSource,
      async (data, requestOptions) => {
        if (!shipment?.list_id) {
          return Promise.reject();
        }

        return handlingApi.viewHandlingList(shipment.list_id, requestOptions);
      },
      {
        transformData: data => [data],
      },
    );

  const dataSource = useDataGrid(fetchHandlingList, {
    modules: ['dataProperties'],
    dataProperties: {
      fixedProperties: [
        {
          key: 'number',
          name: intl.formatMessage({
            id: 'dataGrid.columns.handling.number',
            defaultMessage: 'Number',
            description: 'The column name for column number',
          }),
          type: 'handlingList',
        },
        {
          key: 'status',
          name: intl.formatMessage({
            id: 'dataGrid.columns.handling.status',
            defaultMessage: 'Status',
            description: 'The column name for column status',
          }),
          type: 'status',
        },
        {
          key: 'due_at',
          name: intl.formatMessage({
            id: 'dataGrid.columns.handling.dueAt',
            defaultMessage: 'Due at',
            description: 'The column name for column due at',
          }),
          type: 'datetime',
        },
        {
          key: 'finished_at',
          name: intl.formatMessage({
            id: 'dataGrid.columns.handling.finishedAt',
            defaultMessage: 'Finished at',
            description: 'The column name for column finished at',
          }),
          type: 'datetime',
        },
        {
          key: 'created_at',
          name: intl.formatMessage({
            id: 'dataGrid.columns.handling.createdAt',
            defaultMessage: 'Created at',
            description: 'The column name for column created at',
          }),
          type: 'datetime',
        },
      ],
    },
  });

  const renderHandlingList = handlingList => (
    <>
      <Divider />
      <ListItem
        key={handlingList.id}
        button
        onClick={() => history.push(`/handling-lists/${handlingList.id}`)}
      >
        <ListItemText
          primary={handlingList.number || handlingList.id}
          primaryTypographyProps={{ color: 'primary' }}
          secondary={<HandlingListStatus handlingList={handlingList} />}
        />
      </ListItem>
    </>
  );

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Hidden implementation="js" mdUp>
        <DataList dataSource={dataSource} renderItem={renderHandlingList} />
      </Hidden>
      <Hidden implementation="js" smDown>
        <DataGrid
          dataSource={dataSource}
          formatters={{ handlingList: handlingListFormatter, status: statusFormatter }}
        />
      </Hidden>
    </Card>
  );
};

export default ShipmentHandlingListSection;
